module.exports = __webpack_public_path__ + "static/img/6.a63dd6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/cards/doublelift/6.png
// module id = ivi/
// module chunks = 35